<template>
  <b-overlay :show="loader" rounded="sm">
    <div>
      <Header />
      <div></div>
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <b-card class="p-2" title="Experiments">
            <b-card-body class="p-0 mt-4 mb-4 bg-white rounded">
              <div>
                <div class="responsive-table-main-div">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                      >
                        <b-input-group size="sm">
                          <b-form-input
                            id="filterInput"
                            v-model="filter"
                            type="search"
                            placeholder="Type to Search"
                          />
                          <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">
                              Clear
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </div>
                  </div>
                  <b-table
                    small
                    show-empty
                    striped
                    :busy="isBusy"
                    responsive
                    :items.sync="tableData.experimentList"
                    :current-page="currentPage"
                    :fields="fields"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    no-local-sorting
                    :per-page="perPage"
                    @context-changed="getExperiments"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template #cell(actions)="row">
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="info(row.item)"
                        :disabled="
                          row.item.id == '2e6e84d5-dd20-410f-b536-487b39c131c4'
                        "
                        class="mr-2"
                      >
                        Edit
                      </b-button>
                      <b-button
                        size="sm"
                        variant="outline-danger"
                        :disabled="
                          row.item.id == '2e6e84d5-dd20-410f-b536-487b39c131c4'
                        "
                        @click="showMsgBoxDlt(row.item)"
                      >
                        Delete
                      </b-button>
                    </template>
                  </b-table>
                </div>
                <b-col sm="7" md="3" class="pagination float-right mt-2">
                  <h6 class="text-dark mr-2 mt-1">Perpage</h6>
                  <b-form-select
                    class="mr-4"
                    size="sm"
                    v-model="perPage"
                    :options="pageOptions"
                  ></b-form-select>
                  <b-pagination
                    size="sm"
                    :total-rows="totalRows"
                    v-model="currentPage"
                    :per-page="perPage"
                  ></b-pagination>
                </b-col>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <div class="col-sm-12 col-md-4">
          <b-card
            class="p-2"
            v-bind:title="
              editID !== '' ? 'Update Experiment' : 'Add Experiment'
            "
          >
            <b-card-body class="p-0 mt-4 mb-4 bg-white rounded">
              <div>
                <b-form @submit="onSubmit" @reset="onReset">
                  <b-form-group label="Experiment:" label-for="experiment-name">
                    <b-form-input
                      id="experiment-name"
                      v-model="form.name"
                      placeholder="Enter name of experiment"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Species" label-for="species_id">
                    <b-form-select
                      id="species_id"
                      v-model="form.species_id"
                      :options="speciesList"
                      value-field="id"
                      text-field="name"
                    ></b-form-select>
                  </b-form-group>
                  <b-button
                    type="submit"
                    variant="primary"
                    class="mr-2"
                    :disabled="isLoadingData"
                  >
                    <span v-show="isLoadingData">
                      <b-spinner label="Busy" small></b-spinner>
                    </span>
                    {{ isLoadingData ? "Submitting..." : "Submit" }}
                  </b-button>
                  <b-button type="reset" :disabled="isLoadingData"
                    >Reset</b-button
                  >
                </b-form>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  GET_EXPERIMENTS_LIST,
  ADD_EXPERIMENT,
  UPDATE_EXPERIMENT,
  GET_SPECIES,
} from "../../graphql/fetch-grphql";
import { toastification } from "../../@core/mixins/toastification";
import Header from "./Header.vue";
export default {
  name: "Experiments",
  data() {
    return {
      isBusy: false,
      loader: false,
      filter: null,
      filterOn: [],
      tableData: [],
      speciesList: [],
      fields: [
        {
          key: "created_at",
          label: "Date",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "species",
          label: "Species",
          sortable: true,
        },
        { key: "actions", label: "Actions" },
      ],
      pageOptions: [5, 10, 20, 50],
      currentPage: 1,
      perPage: 10,
      isLoadingData: false,
      form: {
        name: "",
        species_id: "",
      },
      editID: "",
      boxTwo: "",
    };
  },
  mixins: [toastification],
  beforeMount() {
    this.getExperiments();
    this.getSpecies();
  },
  computed: {
    totalRows() {
      return this.tableData.total;
    },
  },
  components: { Header },
  methods: {
    onSubmit(event) {
      this.loader = true;
      event.preventDefault();
      this.isLoadingData = true;
      // alert(JSON.stringify(this.form));
      let variables = {
        name: this.form.name,
        species_id: this.form.species_id,
      };
      if (this.editID !== "") {
        variables.id = this.editID;
        variables.is_deleted = false;
      }
      this.$apollo
        .mutate({
          mutation: this.editID !== "" ? UPDATE_EXPERIMENT : ADD_EXPERIMENT,
          variables,
        })
        .then(() => {
          this.form.name = "";
          this.form.species_id = "";
          this.editID = "";
          // Trick to reset/clear native browser form validation state
          this.show = false;
          this.getExperiments();
          this.loader = false;
        })
        .catch((err) => {
          this.loader = false;
          this.makeToastFail(err);
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.editID = "";
      this.form.name = "";
      this.form.species_id = "";
      // Trick to reset/clear native browser form validation state
      this.isLoadingData = true;
      this.$nextTick(() => {
        this.isLoadingData = false;
      });
    },
    getSpecies() {
      this.$apollo
        .query({
          query: GET_SPECIES,
        })
        .then((res) => {
          this.speciesList = res.data.getSpecies.speciesList;
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    getExperiments(options) {
      this.isBusy = true;
      let orderBy = [];
      orderBy.push(
        options && options.sortBy !== "" ? options.sortBy : "created_at"
      );
      orderBy.push(options ? (options.sortDesc ? "desc" : "asc") : "asc");
      const variables = {
        search: this.filter ? this.filter : "",
        order_by: Object.fromEntries([orderBy]),
        page: this.currentPage ? this.currentPage : 1,
        per_page: this.perPage ? this.perPage : 10,
      };

      this.$apollo
        .query({
          query: GET_EXPERIMENTS_LIST,
          variables,
        })
        .then((res) => {
          this.tableData = res.data.getExperimentList;
          res.data.getExperimentList.experimentList.forEach((element) => {
            let data = element.created_at;
            let date = new Date(parseInt(data));
            element.created_at = `${date.getDate()}/${
              date.getMonth() + 1
            }/${date.getFullYear()}`;
          });
          this.isBusy = false;
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
    info(item) {
      this.editID = item.id;
      this.form = { ...item };
    },
    onDelete(item) {
      // this.isLoadingData = true;
      this.loader = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_EXPERIMENT,
          variables: {
            id: item.id,
            name: item.name,
            species_id: item.species_id,
            is_deleted: true,
          },
        })
        .then(() => {
          this.show = false;
          this.getExperiments();
          this.loader = false;
        })
        .catch((err) => {
          this.loader = false;
          this.makeToastFail(err);
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    },
    showMsgBoxDlt(item) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete this record with linked data.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.onDelete(item);
          }
        })
        .catch((err) => {
          this.makeToastFail(err);
        });
    },
  },
};
</script>

<style scoped>
.mt-2,
.my-2 {
  margin-top: 1.5rem !important;
  margin-right: 1.5rem !important;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: initial;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.responsive-table-main-div {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.pagination .custom-select {
  width: 75px !important;
}
@media only screen and (min-width: 360px) and (max-width: 736px) {
  .pagination {
    flex-wrap: wrap !important;
  }
  .p-3 {
    padding: unset !important;
  }
  .w-75 {
    width: auto !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .pagination {
    flex-wrap: inherit !important;
    float: left !important;
  }
  .p-3 {
    padding: unset;
  }
  .w-75 {
    width: auto;
  }
}
</style>
